import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=63e8d934&scoped=true"
import script from "./Legends.vue?vue&type=script&lang=ts"
export * from "./Legends.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8d934",
  null
  
)

export default component.exports